<template>
    <tool-tip :message="tooltip" class="issues-card-date">
        <div class="d-flex align-center align-self-center" :class="align">
            <svg-icon v-if="showIcon" :icon="calendar" alt="calendar" />
            <span class="issues-card-date__text ml-1 text-size-xs text-secondary-light line-height-1" :class="className">
                {{ formatTimestamp(date, 'dd.MM.yyyy') }}
            </span>
        </div>
    </tool-tip>
</template>

<script setup lang="ts">
import { formatTimestamp } from '@/helpers';
import { IIssuesCardDate } from '../../types';
import SvgIcon from '@/features/common/components/SvgIcon.vue';
import calendar from '@/assets/calendar.svg';
import ToolTip from '@/features/common/components/ToolTip.vue';

withDefaults(defineProps<IIssuesCardDate>(), { align: 'ml-left', showIcon: false, className: 'text-secondary-light font-weight-regular' });
</script>
